export type AgentBetaThemeMode = 'dark' | 'light';

export const AGENT_BETA_THEME_MODE_KEY = 'fyso-agent-beta-theme-mode';

export function readAgentBetaThemeMode(): AgentBetaThemeMode {
  if (typeof window === 'undefined') return 'dark';
  try {
    return window.localStorage.getItem(AGENT_BETA_THEME_MODE_KEY) === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

export function saveAgentBetaThemeMode(mode: AgentBetaThemeMode): void {
  try { window.localStorage.setItem(AGENT_BETA_THEME_MODE_KEY, mode); } catch { /* optional storage */ }
}

export function applyAgentBetaTheme(enabled: boolean, mode: AgentBetaThemeMode): void {
  const root = document.documentElement;
  root.classList.toggle('fyso-beta-theme', enabled);
  root.classList.toggle('light', enabled && mode === 'light');
}
